import { SiteIntegration, UserIdentity } from "~/api/Api";
import FormLabel from "~/components/login/formLabel/FormLabel";
import Select from "~/components/mantine/select/Select";
import { Option, Select as UISelect } from "~/components/ui/select/Select";

import { GoogleAccountHandle } from "../GoogleAccountHandle";
import styles from "./IntegrationConfigurationPanel.module.scss";

export const IntegrationConfigurationPanelReadOnly = ({
  integration,
  identities,
}: {
  integration: SiteIntegration;
  identities: UserIdentity[];
}) => {
  return (
    <div>
      <div className={styles.formRow}>
        <FormLabel label="Google Account" />
        <UISelect
          className={styles.identitySelect}
          value={integration.user_identity_id.toString()}
          disabled={true}
          renderValue={(option) => {
            if (!option || Array.isArray(option)) return null;

            const selectedIdentity = identities.find(
              (identity) => identity.id.toString() === option.value,
            );
            if (!selectedIdentity) return null;

            return (
              <GoogleAccountHandle
                identity={selectedIdentity}
                variant="short"
              />
            );
          }}
        >
          {identities.map((identity) => (
            <Option key={identity.id} value={identity.id.toString()}>
              <GoogleAccountHandle identity={identity} variant="full" />
            </Option>
          ))}
        </UISelect>
      </div>

      <div className={styles.formRow}>
        <FormLabel label="Select property to pull data from:" />
        <Select
          data={
            integration.properties.length > 0
              ? [
                  {
                    value: integration.properties[0]?.id.toString(),
                    label: integration.properties[0]?.name,
                  },
                ]
              : []
          }
          searchable={false}
          disabled={true}
          value={integration.properties[0]?.id.toString()}
        />
      </div>
    </div>
  );
};
